module.exports = __webpack_public_path__ + "assets/MaterialIcons-Regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/material-icons/iconfont/MaterialIcons-Regular.woff2
// module id = 950
// module chunks = 1